// client/src/api/restaurantes.js
import api from "./config.js";

// 🔄 Convertir objeto restaurante a FormData
const toFormData = (restaurante) => {
  console.log("🔄 Convirtiendo a FormData:", restaurante);
  const formData = new FormData();
  
  for (const key in restaurante) {
    // 🚫 Excluir id_restaurante
    if (key === "id_restaurante") continue;
    
    const value = restaurante[key];
    
    // Solo agregar si tiene valor
    if (value !== undefined && value !== null && value !== "") {
      // Para archivos (logo y portada), solo agregar si es un objeto File
      if (key === "logo" || key === "portada") {
        if (value instanceof File) {
          console.log(`  ✅ Agregando archivo ${key}:`, value.name);
          formData.append(key, value);
        } else {
          console.log(`  ⚠️ Saltando ${key} (no es File):`, value);
        }
      } else {
        console.log(`  ✅ Agregando ${key}:`, value);
        formData.append(key, value);
      }
    } else {
      console.log(`  ⏭️ Saltando ${key} (vacío o null)`);
    }
  }
  
  // Mostrar contenido del FormData
  console.log("📦 FormData construido:");
  for (let pair of formData.entries()) {
    console.log(`  ${pair[0]}:`, pair[1]);
  }
  
  return formData;
};


// Obtener todos los restaurantes
export const getRestaurantes = async () => {
  const { data } = await api.get("/restaurantes");
  return data; // { message, restaurantes }
};

// Obtener restaurante por ID
export const getRestaurante = async (id) => {
  const { data } = await api.get(`/restaurantes/${id}`);
  return data;
};

// 📌 Crear restaurante
export const createRestaurante = async (restaurante) => {
  const formData = toFormData(restaurante);
  const { data } = await api.post("/restaurantes", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

// 📌 Actualizar restaurante
export const updateRestaurante = async (id, restaurante) => {
  const formData = toFormData(restaurante);
  const { data } = await api.put(`/restaurantes/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

// Eliminar restaurante
export const deleteRestaurante = async (id) => {
  const { data } = await api.delete(`/restaurantes/${id}`);
  return data;
};

// Cambiar estado del restaurante (activo/inactivo)
export const changeEstadoRestaurante = async (id, estado) => {
  const { data } = await api.patch(`/restaurantes/${id}/estado`, { estado });
  return data;
};
